export default __webpack_public_path__ + "static/media/1.09e27c76.webp";